import { render, staticRenderFns } from "./DataInsightsView.vue?vue&type=template&id=120cbbc8&scoped=true&"
import script from "./DataInsightsView.vue?vue&type=script&lang=js&"
export * from "./DataInsightsView.vue?vue&type=script&lang=js&"
import style0 from "./DataInsightsView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DataInsightsView.vue?vue&type=style&index=1&id=120cbbc8&lang=scss&scoped=true&"
import style2 from "./DataInsightsView.vue?vue&type=style&index=2&id=120cbbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120cbbc8",
  null
  
)

export default component.exports